import Vue from "vue";
import store from "./store";
import VModal from "vue-js-modal";
import vueDebounce from "vue-debounce";
import ProductFactList from "./components/ProductFactList";
import VariantSelector from "./components/VariantSelector";
import SingleVariantFilter from "./components/SingleVariantFilter";
import ConsumptionCalculator from "./components/ConsumptionCalculator";
import DeliverySelector from "./components/DeliverySelector";
import FavouriteIcon from "./components/FavouriteIcon";
import DocumentArchive from "./components/DocumentArchive";
import ProductConfigurator from "./modules/ProductConfigurator/ProductConfigurator";
import ResellerOrderCheckout from "./modules/ResellerOrderCheckout/ResellerOrderCheckout";
import * as VueGoogleMaps from "vue2-google-maps";
import RelatedProductList from "./components/RelatedProductList";
import AddToCartContainer from "./components/AddToCartContainer";
import HandlingFeeMessageCart from "./components/HandlingFeeMessageCart";
import CartSummaryTotalValueOfGoods from "./components/CartSummaryTotalValueOfGoods";
import FreightCalculation from "./components/FreightCalculation";
import QuantityCalculatorCastProductContainer from "./components/QuantityCalculatorCastProductContainer";
import QuantityCalculatorCastProduct from "./components/QuantityCalculatorCastProduct";
import QuantityCalculatorFloorProduct from "./components/QuantityCalculatorFloorProduct";
import QuantityCalculatorMortarProduct from "./components/QuantityCalculatorMortarProduct";
import QuantityCalculatorMortarProductContainer from "./components/QuantityCalculatorMortarProductContainer";
import QuantityCalculatorBlockProduct from "./components/QuantityCalculatorBlockProduct";
import QuantityCalculatorSandboxProduct from "./components/QuantityCalculatorSandboxProduct";
import QuantityCalculatorFogsandProduct from "./components/QuantityCalculatorFogsandProduct";
import QuantityCalculatorUBlockProduct from "./components/QuantityCalculatorUBlockProduct";
import QuantityCalculatorUBlockProductContainer from "./components/QuantityCalculatorUBlockProductContainer";
import ConsumptionCalculatorSand from "./components/ConsumptionCalculatorSand";
import VoucherCampaign from "./components/VoucherCampaign";
import CarbonSavingsCalculation from "./components/ProductPage/CarbonSavingsCalculation";
import ProductEnvironmentDataBase from "./components/ProductPage/ProductEnvironmentDataBase";
import CarbonSavingsCalculationContainer from "./components/ProductPage/CarbonSavingsCalculationContainer";
import DiyVariantItem from "./components/ProductPage/DiyVariantItem";
import { EventBus } from "./events";
import PaymentMethod from "././modules/CheckoutKundPortalen/Components/PaymentMethod";
import CheckoutSummary from "./modules/CheckoutKundPortalen/Components/CheckoutSummary";

import filters from "./filters";

Vue.config.productionTip = false;
Vue.use(VModal);
Vue.use(vueDebounce, {
    listenTo: "input",
    defaultTime: "700ms"
});
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyApk__HmCNbVDJN0ig0B9999Dsc0WKfaJA",
        libraries: "places", // This is required if you use the Autocomplete plugin
    },
});

window.eventBus = EventBus;

new Vue({
    components: {
        ProductFactList,
        VariantSelector,
        SingleVariantFilter,
        ConsumptionCalculator,
        DeliverySelector,
        DocumentArchive,
        ProductConfigurator,
        ResellerOrderCheckout,
        FavouriteIcon,
        RelatedProductList,
        HandlingFeeMessageCart,
        CartSummaryTotalValueOfGoods,
        AddToCartContainer,
        FreightCalculation,
        QuantityCalculatorCastProductContainer,
        QuantityCalculatorCastProduct,
        QuantityCalculatorFloorProduct,
        VoucherCampaign,
        QuantityCalculatorMortarProduct,
        QuantityCalculatorMortarProductContainer,
        QuantityCalculatorBlockProduct,
        QuantityCalculatorSandboxProduct,
        QuantityCalculatorFogsandProduct,
        ConsumptionCalculatorSand,
        QuantityCalculatorUBlockProduct,
        QuantityCalculatorUBlockProductContainer,
        CarbonSavingsCalculation,
        ProductEnvironmentDataBase,
        CarbonSavingsCalculationContainer,
        DiyVariantItem,
        PaymentMethod,
        CheckoutSummary,
    },
    filters,
    store,
}).$mount("#app");
